import 'swiper/css';

import { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { H6 } from './headline';
import Icon, { IconName } from './Icons/Icon';

type IconType = {
  name: IconName;
  text: JSX.Element;
};

const icons: IconType[] = [
  {
    name: 'britishIsles',
    text: (
      <>
        UK-registered
        <br />
        pharmacy
      </>
    ),
  },
  {
    name: 'handshake',
    text: (
      <>
        Includes our clinically-proven
        <br />
        weight-loss programme
      </>
    ),
  },
  {
    name: 'deliveryBox',
    text: (
      <>
        24h-tracked,
        <br />
        discreet delivery
      </>
    ),
  },
  {
    name: 'lifebuoy',
    text: (
      <>
        Ongoing support from
        <br />
        nutritionists and clinicians
      </>
    ),
  },
];

export const GLP1Ribbon = (): JSX.Element => {
  const mobileSlider = (
    <Swiper
      modules={[Autoplay]}
      speed={1400}
      centeredSlides={true}
      loop={true}
      autoplay={{
        delay: 1100,
        disableOnInteraction: false,
        waitForTransition: true,
      }}
      // Disable interaction
      allowTouchMove={false}
    >
      {icons.map(icon => (
        <SwiperSlide key={icon.name}>
          <div className="flex h-24 w-full items-center justify-center">
            <Icon name={icon.name} />
            <div className="ml-3">
              <H6>{icon.text}</H6>
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );

  const desktopRibbon = (
    <>
      {icons.map(icon => (
        <div key={icon.name} className="flex">
          <Icon name={icon.name} />
          <div className="ml-3">
            <H6>{icon.text}</H6>
          </div>
        </div>
      ))}
    </>
  );

  return (
    <div className="h-24 w-full bg-grey-600 text-mono-grey">
      <div className="lg:hidden">{mobileSlider}</div>
      <div className="hidden h-full items-center justify-evenly lg:flex">
        {desktopRibbon}
      </div>
    </div>
  );
};
